<template>
    <span>
        <v-dialog max-width="600px">
       <span column slot="activator" class="fab-container">
            <v-btn icon class="mx-0" @click="edit(name,desc,duration,link)">
                      <v-icon color="teal">edit</v-icon>
           </v-btn>
           
        </span>
         <v-card
          flat
          class="flex"
         >
             <v-card-title primary-title>
                <h1 class="headline mb-1"><b>EDIT MOVIE</b></h1>

             </v-card-title>
              
             <v-card-text class=" text-xs-center display-1  my-2 flex">
            <h6>   
              Note: The unique ID for this movie in this category
              will be the name of the movie which has been stripped 
              of spaces. 
             </h6>
                
             </v-card-text>
             <v-card-text>
                 <v-form class="px-3" ref="editform"> 
                     <v-text-field label="Movie Name*" v-model="nameloc" @keypress="isName" :rules="nameRules" prepend-icon="comment"></v-text-field>
                     <v-text-field label="Category*" v-model="category" prepend-icon="money" readonly></v-text-field>
                     <v-textarea label="Description" v-model="descloc" :rules="descRules" prepend-icon="edit"></v-textarea>
                     <v-text-field label="Preview Link Address*" v-model="linkloc" prepend-icon="web" :rules="nameRules"></v-text-field>
                     
                     <v-text-field label="Duration" v-model="duraloc" prepend-icon="edit"></v-text-field>
                     
                    <v-icon>file_upload</v-icon> <span class="flex"><b>   Select Banner  </b> <input type="file" :class="id"/></span>
                     <br/><span v-if="fileerror" class="red--text">You must select an image:png,jpeg or jpg</span>
               
                     <span> * indicates required field </span> </v-form>
             </v-card-text>
             <v-divider></v-divider>
              <v-card-actions>
                <v-btn outline block color="brown" @click="add()" :disabled="isDisabled" :loading="isDisabled">Edit Movie</v-btn>
             </v-card-actions>
         </v-card>
        </v-dialog>
   </span>
</template>

<script>
import {editModuleWithAttachment} from '@/model';
import {trim} from '@/validator';
import moment from 'moment';

export default {
    name: 'EditMovie',
    props:{
        id:{
            required:true,
        },
        name :{
            required:true
        },
        category:{
            required:true
        },
        desc:{
            required:true
        },
        duration:{
            required:true
        },
        link:{
            required:true
        }


    },computed:{
            descloc :{
                 get:function(){
                     return this.descda;
                 },
                 set:function(desc){
                      this.descda = desc
                 }
                 
                 
                 },
            nameloc:{
                 
                get:function(){
                     return this.nameda;
                 },
                 set:function(name){
                      this.nameda = name
                 }
                 
                 
                 },
                  duraloc:{
                 
                get:function(){
                     return this.durada;
                 },
                 set:function(duration){
                      this.durada = duration
                 }
                 
                 
                 },
                 linkloc:{
                 
                get:function(){
                     return this.linkda;
                 },
                 set:function(link){
                      this.linkda = link
                 }
                 
                 
                 }
      
    },
    data() {
        return {
            isDisabled:false,
            nameda:this.name,
            descda:this.desc,
            durada:this.duration,
            linkda:this.link,
            fileerror:false,
           nameRules:[
               v => v.length >=3  || "Minimum length is 3 characters",
               v => v.length <=80  || "Maximum length is 80 characters",
               
           ],
           descRules:[
               v => v.length >=15  || "Minimum length is 15 characters",
               v => v.length <=200  || "Maximum length is 200 characters" 
           ]

        };
    },
    methods: {
        edit(name,desc,dura,link){
            console.log("Edit ",name," Desc ",desc," Dura ",dura," Link ",link);
            this.nameda = name;
            this.descda  = desc;
            this.durada  = dura;
            this.linkda = link;
        },
        isName:function(evt){
            evt = (evt) ? evt : window.event;
            let charcode = (evt.which) ? evt.which : evt.keycode;
            if((charcode > 31 && (charcode < 48 || charcode > 57)) && charcode !== 46){
                return true;
            }else{
                evt.preventDefault();
            }
        },
        add() {
            let self=this;
            if(this.$refs.editform.validate()){
            let datenow = moment().format('DD/MM/YYYY');
            let input = document.querySelector('.'+this.id);
            let file = input.files[0];
            if(file){
                 console.log(file.type);
            
              if((file.type !='image/jpeg') && (file.type !='image/png')){
                   this.fileerror = true;
                    return;
                }
                this.fileerror = false;
            }else{
                
                this.fileerror = true;
                return;
            }
            
            let useradd = this.$store.getters.getStaff.name;
            let movName = this.nameloc;
            let oldname = this.id;
           
            var trimmed = trim(movName);
            let newname = trimmed+this.category;
            newname = newname.toLowerCase();
            let newitem = {name:newname,movName:movName,link:this.linkloc,duration:this.duraloc,category:this.category,desc:this.descloc,file:file.type,dateadded:datenow,useredit:useradd};
          
            console.log(newitem);
            self.isDisabled = true;
            editModuleWithAttachment('movie',oldname,newname,newitem,file,function(response){
              if(response){
                     console.log("This is response: ",response);
                      alert('It has been succesfully added to your movies');
                      self.$store.dispatch('updateMovies',true);
                      self.isDisabled = false;
                  }else{
                      console.log(null);
                      self.isDisabled = false;
                  }

              });

                          }
        }
    }
};
</script>

<style scoped>
</style>